import { motion } from 'framer-motion';

function MovingText() {
  return (
    <div className="bg-pacieh-blue/90 text-white py-2 overflow-hidden">
      <div className="container relative">
        <motion.div
          initial={{ x: "100%" }}
          animate={{ x: "-100%" }}
          transition={{
            duration: 28,
            repeat: Infinity,
            ease: "linear"
          }}
          className="whitespace-nowrap text-xs sm:text-sm font-bold tracking-wider flex items-center gap-6"
        >
          <span>PAN-AFRICAN COMMUNITY INITIATIVE FOR EDUCATION AND HEALTHCARE (PACIEH)</span>
          <span className="text-[#8de058]">•</span>
          <span className="text-[#8de058]">NEW REPORT: 17th Annual NTD NGO Network Conference Kigali Report Available</span>
          <span>•</span>
          <span>TRANSFORMING RURAL HEALTHCARE & SCHOOL NUTRITION ACROSS AFRICA</span>
        </motion.div>
      </div>
    </div>
  );
}

export default MovingText; 